import { PAYMENT_CONFIG } from "./Hosts";

const SWIGGY_WEBVIEW_URL_PREFIX = PAYMENT_CONFIG.SWIGGY_WEBVIEW_URL_PREFIX ?? "swiggy://webviewV2?webview_url";
const PORTAL_HELP_FILE_UPLOAD_URL = PAYMENT_CONFIG.PORTAL_HELP_FILE_UPLOAD_URL ?? "https://www.swiggy.com";
const PORTAL_HELP_FILE_UPLOAD_BUCKET = PAYMENT_CONFIG.PORTAL_HELP_FILE_UPLOAD_BUCKET ?? "dineout-rx-bills";

export const BILL_IMAGES_ERROR_MESSAGES = {
    CANNOT_CLEAR_AND_UPLOAD_SIMULTANEOUSLY: "Cannot clear images and upload new images simultaneously",
    MUST_SPECIFY_OPERATION: "Must specify either clearImages or uploadedFileURLs",
} as const;

export const BILL_IMAGE_WEBVIEW_ERROR_MESSAGES = {
    UPLOAD_ERROR: "Failed to upload bill details",
} as const;

export const BILL_IMAGE_WEBVIEW_CONFIG = {
    SOURCE: "bill_image_half_card",
    LINK: `${SWIGGY_WEBVIEW_URL_PREFIX}=${encodeURIComponent(
        `${PORTAL_HELP_FILE_UPLOAD_URL}/help/file-upload?bucket_name=${PORTAL_HELP_FILE_UPLOAD_BUCKET}&folder_path=mmt&file_type=image&screen_name=dineout-bill-uploads&max_items=2&isWebviewDataSyncEnabled=true`,
    )}`,
} as const;
